import React from 'react';
import PropTypes from 'prop-types';

const CardStat = ({
  shadowDistance = 0,
  label,
  stat,
  width,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `card-stat shadow-${shadowDistance} ${className}`,
    style: {
      width,
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card__label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "card__stat"
  }, stat));
};

CardStat.propTypes = {
  label: PropTypes.string.isRequired,
  stat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.number,
  shadowDistance: PropTypes.oneOf([0, 1, 2, 3]),
  className: PropTypes.string,
  style: PropTypes.object
};
export default CardStat;